<template>
  <div class="panel panel-default panel-top-bordered">
    <div class="panel-heading">
      <h5>
        Page Views
      </h5>
    </div>

    <div class="panel-body text-center">
      <canvas ref="chart" width="800" height="250"/>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import http from '@/http'

export default {
  props: {
    portalCompanyId: {
      required: true,
    },

    filters: {
      required: true,
    }
  },

  data() {
    return {
      result: null,
      chartData: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    filters() {
      this.load()
    },
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/portal-companies/' + this.portalCompanyId + '/statistics/trended-content/' + this.filters.from +'/' + this.filters.to).then(response => {
        this.result = response.data.data

        this.loading = false

        this.draw()
      })
    },

    draw() {
      if (this.chartData) {
        this.chartData.destroy()
      }

      this.$nextTick(() => {
        this.chartData = new Chart(this.$refs.chart, {
          type: 'bar',

          data: {
            labels: this.result.attributes.value.dates,

            datasets: [
              {
                label: 'Articles and topics',
                data: this.result.attributes.value.articles_and_topics,
                backgroundColor: '#fd612c',
                borderColor: '#fd612c',
                color: '#fd612c',
              },
              {
                label: 'Events',
                data: this.result.attributes.value.events,
                backgroundColor: '#eec300',
                borderColor: '#eec300',
                color: '#eec300',
              },
              {
                label: 'Files',
                data: this.result.attributes.value.files,
                backgroundColor: '#37c5ab',
                borderColor: '#37c5ab',
                color: '#37c5ab',
              },
              {
                label: 'Jobs',
                data: this.result.attributes.value.jobs,
                backgroundColor: '#7a6ff0',
                borderColor: '#7a6ff0',
                color: '#7a6ff0',
              },
            ]
          },

          options: {
            maintainAspectRatio: false,

            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  precision: 0,
                  beginAtZero: true
                }
              }]
            },

            plugins: {
              datalabels: {
                display: false
              }
            },

            tooltips: {
              callbacks: {
                label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + d.datasets[t.datasetIndex].data[t.index]
              }
            },
          }
        })
      })
    },
  }
}
</script>
